/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from 'react'
import ReactPinterestTag from 'react-pinterest-tag'
import './src/fonts/stylesheet.css'
import RootElement from './src/components/root-element'
import { setImpactRadiusId, trackIdentifyUser } from './src/components/impact-radius'
import './src/styles/breadcrumb.css'
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => <RootElement>{element}</RootElement>

export const onClientEntry = () => {
  setImpactRadiusId()
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation) {
    ReactPinterestTag.init(process.env.PINTEREST_TAG_ID)
  }

  ReactPinterestTag.pageView()
  ReactPinterestTag.track('pagevisit')

  const pathname = location.pathname

  if (pathname.startsWith('/collections')) {
    ReactPinterestTag.track('viewcategory')
  }

  trackIdentifyUser()
}

export const registerServiceWorker = () => false

export const onServiceWorkerActive = async () => {
  await caches.keys().then(names => {
    for (const name of names) {
      caches.delete(name)
    }
  })
}
